/**
 * Smooth-scrolls section CTA buttons to the bundle picker in the buy box,
 * falling back to the #buy-box wrapper, then to the top of the page
 * (e.g. when the section is used on a non-product template).
 *
 * Opt in from Liquid with either:
 *   <a href="#buy-box" ...>            (works without JS too)
 *   <a data-scroll-to-buy ...>
 */
(function () {
  var TARGET = 'buy-box';
  var BUNDLE_TARGET = '.kaching-bundles__block-title';
  var GAP = 12;

  function stickyHeaderHeight() {
    var height = 0;
    var candidates = document.querySelectorAll('.page-header, .sticky-header');

    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      var position = window.getComputedStyle(el).position;
      if (position !== 'fixed' && position !== 'sticky') continue;

      var rect = el.getBoundingClientRect();
      // Only count headers that are actually pinned near the top right now.
      if (rect.top <= 1 && rect.bottom > height) height = rect.bottom;
    }

    return height;
  }

  function scrollToBuyBox() {
    // Prefer the bundle picker (app block, renders async); fall back to the
    // buy box wrapper, then to the top of the page.
    var target = document.querySelector(BUNDLE_TARGET) || document.getElementById(TARGET);
    var top = 0;

    if (target) {
      top = target.getBoundingClientRect().top + window.pageYOffset - stickyHeaderHeight() - GAP;
      if (top < 0) top = 0;
    }

    try {
      window.scrollTo({ top: top, left: 0, behavior: 'smooth' });
    } catch (_) {
      window.scrollTo(0, top);
    }
  }

  document.addEventListener('click', function (event) {
    var el = event.target;
    if (!el || !el.closest) return;

    var trigger = el.closest('[data-scroll-to-buy], a[href="#' + TARGET + '"]');
    if (!trigger) return;

    event.preventDefault();
    scrollToBuyBox();
  });
})();
